export default {
  download: {
    appName: 'Blueshark App',
    slogan: '스마트한 이동, 한 손에 장악하다',
    tips1: '최소 시스템 요구 사항: ',
    tips2: 'Android 8.0 이상; iOS 12 이상',
    weTips1: '현재 환경은 다운로드 및 설치를 지원하지 않습니다.',
    weTips2: '1.오른쪽 상단··· 을 선택하고 브라우저에서 엽니다.',
    weTips3: '2.브라우저를 열어 다운로드 및 설치',
    iosListTitle: '국가 또는 지역을 선택하십시오',
    androidListTitle: '필요한 앱 버전을 선택하세요',
    ChineseVersion: '중국 본토 버전',
    InoternationalVersion: '국제 지역 버전',
    asian: 'Asia-pacific region',
    european: 'European region'
  },
  support: {
    title: 'Support',
    productAndService: 'Product Support and Service',
    service: 'Maintenance and Service Policy',
    toService: 'Click to View Product After-Sales Maintenance Policy',
    view: 'View Now',
    product: 'User Manual',
    toProduct: 'Click to View and Download User Manual',
    chooseModel: 'Please Select the Model Based on Your Purchase',
    rModel: 'Blueshark R Series',
    hModel: 'Blueshark H Series'
  },
  R1config: {
    battery: 'Battery',
    capacity: 'Battery Capacity',
    NEDC: 'NEDC Range',
    powerType: 'Battery Cell Type',
    automotive: 'Lithium-Ion Battery Packs',
    charger: 'Charger',
    performance: 'Performance',
    motor: 'Motor',
    highSpeedMotor: 'High-speed brushless permanent magnet gear motor',
    topSpeed: 'Top Speed',
    ratedPower: 'Rated Power',
    peakPower: 'Peak Power',
    torque: 'Torque',
    gradability: 'Gradability',
    turbo: 'Turbo Mode',
    yes: 'Yes',
    no: 'No',
    mam: 'Move Assist Mode / MAM',
    smart: 'Smart',
    panel: 'Panel',
    IPSScreen: '10" Full-color High-definition IPS Screen',
    LCDScreen: '10" LCD Segment Screen',
    bluetooth: 'Bluetooth Navigation',
    frontalCamera: 'Frontal Camera',
    RearCamera: 'Rear Camera',
    optional: 'Optional',
    RAM: 'RAM',
    viewWhenTurn: 'Display rear view when turning',
    remainRange: 'Remain Range',
    bluesharkApp: 'Blueshark App',
    wireless: 'Wireless Connection',
    sensors: 'Number of Sensors',
    upgrade: 'OTA Upgrade',
    safe: 'Safe',
    smartKey: 'Bluetooth Smart Key',
    steeringLock: 'Electronic Steering Lock',
    seatLock: 'Electronic Seat Lock',
    triMode: 'Tri-mode Position',
    brake: 'Brake',
    CBS: 'Front & Rear Disc Brakes with CBS',
    ADAS: 'ADAS',
    remoteAlarm: 'Remote Alarm',
    sideStand: 'Side Stand Cutoff',
    virtualVroom: 'Virtual Vroom',
    light: 'Light',
    autoHeadlight: 'Auto Headlight',
    turnSignal: 'Turn Signal',
    HazardLight: 'Hazard Light',
    seatLight: 'Seat Illumination Light',
    carpetLight: 'Ambient Carpet Light',
    multimedia: 'Multimedia',
    speaker: 'Speaker',
    HighPowerSpeaker: 'High-power Speaker',
    basic: 'Basic',
    size: 'Size',
    LWH: '(Length * Width * Height)',
    wheelbase: 'Wheelbase',
    tire: 'Tire',
    front: 'Front',
    rear: 'Rear',
    groundClearance: 'Ground Clearance',
    weight: 'Weight(without battery)',
    colors: 'Colors',
    color:
      'Spindrift White / Deepsea Black / Blueshark Blue / Pine Green / Coconut Brown'
  },
  H1Product: {
    firstBG: {
      title: '블루샤크 H1',
      info: '스마트 전기 스쿠터',
      slogan: ' ' // 无韩文文案
    },
    colorName: {
      while: 'Soft Sand White',
      blue: 'Sea Salt Blue',
      green: 'Seaweed Green',
      pink: 'Coral Pink',
      black: 'Reef Black'
    },
    colorNameSlogan: {
      while: ' ', // 无韩文文案
      blue: ' ', // 无韩文文案
      green: ' ', // 无韩文文案
      pink: ' ', // 无韩文文案
      black: ' ' // 无韩文文案
    },
    performance: {
      title: '빠른 스피드',
      subTitle:
        '고속 브러시리스 영구 자석 기어 모터.<br/>자동차급의 기어박스 설계와 직결 구동기술은 높은 효율과 안정적인 동력 전달을 보장합니다.',
      maxPower: '최대파워',
      maxSpeed: '최고속도',
      torque: '휠 토크',
      climbing: '등판능력',
      swerve: '회전반경'
    },
    // TODO mode 需要增加新文案对应关系
    gear: {
      title: '벡터 알고리즘, 부드러운 주행',
      subTitle: '3가지 일반 주행모드와 2가지 보조 주행모드',
      model1: ' ', // 无韩文文案
      model2: ' ', // 无韩文文案
      model3: ' ' // 无韩文文案
    },
    control: {
      title: '섬세한 핸들링',
      info: '복잡한 환경을 간편하게 탐색'
    },
    battery: {
      title: '블루샤크 배터리 팩 2.0', // 韩文调换位置
      info: '안전, 스마트, 효율성 및 신뢰성', // 韩文调换位置
      fastCharge: '급속 충전',
      largeCapacity: '초 고용량',
      endurance: '주행가능거리',
      highlight1: '보다 안전한',
      highlight2: '믿을수 있는',
      highlightInfo1: ' ', // 无韩文文案
      highlightInfo2: ' ', // 无韩文文案
      highlightInfo3: ' ', // 无韩文文案
      highlightInfo4: ' ', // 无韩文文案
      highlightInfo5: ' ' // 无韩文文案
    },
    cab: {
      title: `블루샤크 스마트<br/> 배터리 교환 시스템`,
      slogan: ' ',
      noFeelChange: '无感换电',
      speedSwapping: '极速充电',
      info1: '3 秒换电',
      info2: '仅需两步，即换即走',
      info3: '2h 快速充电',
      info4: '单日可换电 150 次'
    },
    mam: {
      slogan: ' '
    },
    chip: {
      title: '궁극의 두뇌 파워',
      subTitle2: '파워 도메인 컨트롤로 + 시스템 도메인 컨트롤러',
      highDot1: '모터 컨트롤 유닛',
      highDot2: '배터레 매니지먼트 시스템',
      highDot3: '에너지 분배',
      content1:
        '시스템 도메인 컨트롤러는 4G 통신 모듈을 통해 블루샤크의 IoT 시스템에 연결되고, 다른 컨트롤러는 실시간으로 주행 상태를 모니터링하고 조정합니다.',
      content2:
        '두 도메인 컨트롤러 모두 독립적으로 작동하거나 CAN 버스를 통해 하나의 유닛으로 연결할 수 있습니다.',
      content3:
        '시스템 도메인 컨트롤러는 4G 통신 모듈을 통해 블루샤크의 IoT 시스템에 연결되고, 다른 컨트롤러는 실시간으로 주행 상태를 모니터링하고 조정합니다.',
      content4:
        '두 도메인 컨트롤러 모두 독립적으로 작동하거나 CAN 버스를 통해 하나의 유닛으로 연결할 수 있습니다.'
    },
    os: {
      title: 'ArkRide OS 2.0',
      info1: '스마트한 운영체제',
      info2: ' ',
      info3: ' ',
      content1: '출발 속도 향상',
      content2: '안정성 증가',
      content3: '향상된 피드백 속도'
    },
    screen: {
      title: '플로팅 스타일 디스플레이 패널',
      info:
        'Blueshark H1은 운행상태와 음악재생에 이르기까지 모든 정보를 보여주는 풀 컬러의 고휘도 풀 HD 패널 디스플레이를 제공합니다.<br /> 위쪽에는 운전 환경을 실시간으로 감지하는 조도센서가 있습니다.'
    },
    handlebar: {
      title: '손끝으로 느끼는 재미',
      info: ' ',
      content: ' '
    },
    key: {
      title: '직관적인 자동차급<br/> 블루투스 스마트 키 시스템',
      info: ' ',
      highDot1: '블루투스',
      highDot2: '블루샤크 앱'
    },
    app: {
      title1: '블루샤크 앱',
      title2: ' ',
      info: ' ',
      highDot1: '차량 위치',
      highDot2: '전력 통계',
      highDot3: '경로 추적',
      highDot4: '주행거리 기록'
    },
    bikeColor: {
      title: '블루샤크 H1컬러'
    },
    config: {
      title: 'Blueshark H1',
      c1: '정격 출력',
      c2: '배터리 용량',
      c3: '최고속도',
      c4: '브레이크 시스템',
      c5: '전/후 디스크 브레이크',
      c6: '지능형 운영체제',
      c7: '최대 운반 용량',
      c8: '중량(배터리 포함)',
      c9: '중앙 제어 계기',
      c10: '10" 풀 컬러 고화질 IPS 스크린',
      c11: '휠베이스',
      c12: '시트 높이',
      c13: '최대 출력',
      c14: '주행가능거리',
      c15: '지능형 중앙제어 시스템',
      c16: '전원 및 시스템 도메인 컨트롤러',
      c17: '지능형 DAS',
      c18: '시작 방법',
      c19: '블루투스 스마트 키',
      c21: '바디 컬러',
      c22: '회전반경',
      c23: '치수',
      c24: '최저 지상고'
    }
  },
  iosAsianCountryList: [
    { country: 'Australia', url: 'https://apps.apple.com/au/app/id1512077089' },
    { country: 'Cambodia', url: 'https://apps.apple.com/kh/app/id1512077089' },
    { country: 'China', url: 'https://apps.apple.com/cn/app/id1455603928' },
    { country: 'HongKong', url: 'https://apps.apple.com/hk/app/id1512077089' },
    { country: 'Indonesia', url: 'https://apps.apple.com/id/app/id1512077089' },
    { country: 'Korea', url: 'https://apps.apple.com/kr/app/id1512077089' },
    { country: 'Macao', url: 'https://apps.apple.com/mo/app/id1512077089' },
    { country: 'Malaysia', url: 'https://apps.apple.com/my/app/id1512077089' },
    {
      country: 'Philippines',
      url: 'https://apps.apple.com/ph/app/id1512077089'
    },
    { country: 'Singapore', url: 'https://apps.apple.com/sg/app/id1512077089' },
    { country: 'Taiwan', url: 'https://apps.apple.com/tw/app/id1512077089' },
    { country: 'Thailand', url: 'https://apps.apple.com/th/app/id1512077089' },
    { country: 'Vietnam', url: 'https://apps.apple.com/vn/app/id1512077089' }
  ],
  iosEuropeanCountryList: [
    { country: 'Albania', url: 'https://apps.apple.com/al/app/id1512077089' },
    { country: 'Austria', url: 'https://apps.apple.com/at/app/id1512077089' },
    { country: 'Belarus', url: 'https://apps.apple.com/by/app/id1512077089' },
    { country: 'Belgium', url: 'https://apps.apple.com/be/app/id1512077089' },
    {
      country: 'Bosnia & Herzegovina',
      url: 'https://apps.apple.com/ba/app/id1512077089'
    },
    { country: 'Bulgaria', url: 'https://apps.apple.com/bg/app/id1512077089' },
    { country: 'Croatia', url: 'https://apps.apple.com/hr/app/id1512077089' },
    {
      country: 'Czech Republic',
      url: 'https://apps.apple.com/cz/app/id1512077089'
    },
    { country: 'Denmark', url: 'https://apps.apple.com/dk/app/id1512077089' },
    { country: 'Estonia', url: 'https://apps.apple.com/ee/app/id1512077089' },
    { country: 'France', url: 'https://apps.apple.com/fr/app/id1512077089' },
    { country: 'Finland', url: 'https://apps.apple.com/fi/app/id1512077089' },
    { country: 'Germany', url: 'https://apps.apple.com/de/app/id1512077089' },
    { country: 'Greece', url: 'https://apps.apple.com/gr/app/id1512077089' },
    { country: 'Hungary', url: 'https://apps.apple.com/hu/app/id1512077089' },
    { country: 'Iceland', url: 'https://apps.apple.com/is/app/id1512077089' },
    { country: 'Italy', url: 'https://apps.apple.com/it/app/id1512077089' },
    { country: 'Ireland', url: 'https://apps.apple.com/ie/app/id1512077089' },
    { country: 'Latvia', url: 'https://apps.apple.com/lv/app/id1512077089' },
    { country: 'Lithuania', url: 'https://apps.apple.com/lt/app/id1512077089' },
    {
      country: 'Luxembourg',
      url: 'https://apps.apple.com/lu/app/id1512077089'
    },
    { country: 'Malta', url: 'https://apps.apple.com/mt/app/id1512077089' },
    { country: 'Moldova', url: 'https://apps.apple.com/md/app/id1512077089' },
    {
      country: 'Montenegro',
      url: 'https://apps.apple.com/me/app/id1512077089'
    },
    {
      country: 'Netherlands',
      url: 'https://apps.apple.com/nl/app/id1512077089'
    },
    { country: 'Norway', url: 'https://apps.apple.com/no/app/id1512077089' },
    { country: 'Poland', url: 'https://apps.apple.com/pl/app/id1512077089' },
    { country: 'Portugal', url: 'https://apps.apple.com/pt/app/id1512077089' },
    { country: 'Romania', url: 'https://apps.apple.com/ro/app/id1512077089' },
    { country: 'Russia', url: 'https://apps.apple.com/ru/app/id1512077089' },
    { country: 'Serbia', url: 'https://apps.apple.com/rs/app/id1512077089' },
    { country: 'Slovakia', url: 'https://apps.apple.com/sk/app/id1512077089' },
    { country: 'Slovenia', url: 'https://apps.apple.com/si/app/id1512077089' },
    { country: 'Spain', url: 'https://apps.apple.com/es/app/id1512077089' },
    { country: 'Sweden', url: 'https://apps.apple.com/se/app/id1512077089' },
    {
      country: 'Switzerland',
      url: 'https://apps.apple.com/ch/app/id1512077089'
    },
    { country: 'Ukraine', url: 'https://apps.apple.com/ua/app/id1512077089' },
    {
      country: 'United Kingdom',
      url: 'https://apps.apple.com/gb/app/id1512077089'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/i18n/kr.js